export default __webpack_public_path__ + "static/media/i_bus-dbl_yl.50737a3a.svg";